import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './SrTag.less';

export const SR_TAG_THEME_GREEN_WHITE = 'SR_TAG_THEME_GREEN_WHITE';
export const SR_TAG_THEME_WHITE_BLACK = 'SR_TAG_THEME_WHITE_BLACK';
export const SR_TAG_THEME_WHITE_GREEN = 'SR_TAG_THEME_WHITE_GREEN';
export const SR_TAG_THEME_GOLD_WHITE = 'SR_TAG_THEME_GOLD_WHITE';
export const SR_TAG_THEME_BLUE_WHITE = 'SR_TAG_THEME_BLUE_WHITE';
export const SR_TAG_THEME_BLUE_WHITE_SMALL = 'SR_TAG_THEME_BLUE_WHITE_SMALL';
export const SR_TAG_THEME_PURPLE_WHITE = 'SR_TAG_THEME_PURPLE_WHITE';
export const SR_TAG_THEME_GREEN_ADOBE = 'SR_TAG_THEME_GREEN_ADOBE';
export const SR_TAG_THEME_ORANGE_WHITE = 'SR_TAG_THEME_ORANGE_WHITE';
export const SR_TAG_THEME_RED_WHITE = 'SR_TAG_THEME_RED_WHITE';
export const SR_TAG_THEME_LIGHTGREEN_GREEN = 'SR_TAG_THEME_LIGHTGREEN_GREEN';
export const SR_TAG_THEME_LIGHTBLUE_BLACK = 'SR_TAG_THEME_LIGHTBLUE_BLACK';
export const SR_TAG_THEME_LIGHTBLUE_BLACK_HOVER = 'SR_TAG_THEME_LIGHTBLUE_BLACK_HOVER';
export const SR_TAG_THEME_GREY_OUTLINE = 'SR_TAG_THEME_GREY_OUTLINE';
export const SR_TAG_THEME_ORANGE_OUTLINE = 'SR_TAG_THEME_ORANGE_OUTLINE';
export const SR_TAG_THEME_ORANGE_TEXT = 'SR_TAG_THEME_ORANGE_TEXT';
export const SR_TAG_THEME_GREEN_TEXT = 'SR_TAG_THEME_GREEN_TEXT';

export const SR_TAG_THEME_TO_CLASSNAME_MAPPING = {
  [SR_TAG_THEME_GREEN_WHITE]: 'srTagThemeGreenWhite',
  [SR_TAG_THEME_GOLD_WHITE]: 'srTagThemeGoldWhite',
  [SR_TAG_THEME_BLUE_WHITE]: 'srTagThemeBlueWhite',
  [SR_TAG_THEME_BLUE_WHITE_SMALL]: 'srTagThemeBlueWhiteSmall',
  [SR_TAG_THEME_PURPLE_WHITE]: 'srTagThemePurpleWhite',
  [SR_TAG_THEME_ORANGE_WHITE]: 'srTagThemeOrangeWhite',
  [SR_TAG_THEME_GREEN_ADOBE]: 'srTagThemeGreenAdobe',
  [SR_TAG_THEME_WHITE_BLACK]: 'srTagThemeWhiteBlack',
  [SR_TAG_THEME_WHITE_GREEN]: 'srTagThemeWhiteGreen',
  [SR_TAG_THEME_RED_WHITE]: 'srTagThemeRedWhite',
  [SR_TAG_THEME_LIGHTGREEN_GREEN]: 'srTagThemeLightgreenGreen',
  [SR_TAG_THEME_LIGHTBLUE_BLACK]: 'srTagThemeLightblueBlack',
  [SR_TAG_THEME_LIGHTBLUE_BLACK_HOVER]: 'srTagThemeLightblueBlackHover',
  [SR_TAG_THEME_GREY_OUTLINE]: 'srTagThemeGreyOutline',
  [SR_TAG_THEME_ORANGE_OUTLINE]: 'srTagThemeOrangeOutline',
  [SR_TAG_THEME_ORANGE_TEXT]: 'srTagThemeOrangeText',
  [SR_TAG_THEME_GREEN_TEXT]: 'srTagThemeGreenText',
};
export const SR_TAG_THEMES = Object.keys(SR_TAG_THEME_TO_CLASSNAME_MAPPING);

const SrTag = ({ theme, className, children, onClick, variation }) => {
  return (
    <div
      styleName={classnames('SrTag', SR_TAG_THEME_TO_CLASSNAME_MAPPING[theme], variation)}
      className={className}
      onClick={onClick}
    >
      <span>{children}</span>
    </div>
  );
};

SrTag.propTypes = {
  theme: PropTypes.oneOf(SR_TAG_THEMES),
  children: PropTypes.node,
  onClick: PropTypes.func,
  variation: PropTypes.string,
};

SrTag.defaultProps = {
  theme: SR_TAG_THEME_GREEN_WHITE,
};

SrTag.displayName = 'SrTag';

export default SrTag;
